const isProduction = () => {
    return (process.env.NODE_ENV === 'production');
};

export const SERVER_ADDR = isProduction() ? "https://api.boroin.com" : "http://localhost:4500";
export const API_PATH = "api/v1";